import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const postTimesheet = async (timesheet) => {
  let config = {
    method: "post",
    url: "timesheet/api/v1/timesheet/",
    headers: {
      "Content-Type": "application/json",
    },
    data: timesheet,
  };

  return await axios.request(config);
};
export const usePostTimesheet = () => {
  return useMutation(["post-timesheet"], postTimesheet);
};

const getTimeSheet = async (query) => {
  let [, employee_uuid, project_name] = query.queryKey;
  project_name = encodeURIComponent(project_name);
  let config = {
    method: "get",
    url: `/timesheet/api/v1/timesheet/?resource__employee_uuid=${employee_uuid}&projects__project_name=${project_name}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};
export const useGetTimesheetByUUID = (employee_uuid, project_name) => {
  return useQuery(
    ["get-employee-timesheet", employee_uuid, project_name],
    getTimeSheet,
    { enabled: false, cacheTime: 0 }
  );
};

const getEmployeeTimeSheet = async (query) => {
  let [, employee_uuid, project_name, date] = query.queryKey;
  project_name = encodeURIComponent(project_name);
  let config = {
    method: "get",
    url: `/timesheet/api/v1/timesheet_employee_view/?resource__employee_uuid=${employee_uuid}&projects__project_name=${project_name}&date=${date}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};
export const useGetEmployeeTeamsheetByUUID = (
  employee_uuid,
  project_name,
  date
) => {
  return useQuery(
    ["get-employee-timesheet", employee_uuid, project_name, date],
    getEmployeeTimeSheet,
    { enabled: false }
  );
};

//API DELETE METHOD

const timeSheetDeleteById = async (id) => {
  try {
    const response = await axios.delete(
      `/timesheet/api/v1/timesheet_update_view/${id}/`
    );
    return response.data;
  } catch (error) {
    // Handle error or throw it again
    throw error;
  }
};

export const useTimeSheetDeleteById = () => {
  return useMutation(["timesheet-delete"], timeSheetDeleteById);
};

// Employee Info Request
const timeSheetUpdateFn = async (timesheetData) => {
  let { rowId, patchData } = timesheetData;
  let config = {
    method: "patch",
    url: `/timesheet/api/v1/timesheet_update_view/${rowId}/`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: patchData,
  };
  return await axios.request(config);
};
export const useTimeSheetUpdateFn = () => {
  return useMutation(["timesheet-update"], timeSheetUpdateFn);
};

const getEmployeeTimeSheetSummary = async (query) => {
  let [, date] = query.queryKey;
  // project_name = encodeURIComponent(project_name);
  let config = {
    method: "get",
    url: `/timesheet/api/v1/timesheet_summary_report/?date=${date}`,
    // url: `/timesheet/api/v1/timesheet_summary_report/?resource__employee_uuid=${employee_uuid}&projects__project_name=${project_name}&date=${date}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};
export const useGetEmployeeTimemsheetSummary = (date) => {
  return useQuery(
    ["get-employee-timesheet-summary", date],
    getEmployeeTimeSheetSummary
  );
};

//WorkDays
const getWorkDays = async () => {
  let config = {
    method: "get",
    url: "/timesheet/api/v1/workdays/",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};

export const useGetWorkDaysList = () => {
  return useQuery(["get-all-workdays"], getWorkDays);
};

const getEmployeeWorkDaysDetail = async (query) => {
  let [, employee_uuid] = query.queryKey;
  let config = {
    method: "get",
    url: `/timesheet/api/v1/employee-workdays/by-employee/${employee_uuid}/`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};
export const useGetEmployeeWorkDaysDetail = (employee_uuid) => {
  return useQuery(
    ["get-employeeworkdetails-by-uuid", employee_uuid],
    getEmployeeWorkDaysDetail,
    { enabled: employee_uuid ? true : false }
  );
};

const createEmployeeWorkDays = async (data) => {
  let config = {
    method: "post",
    url: "/timesheet/api/v1/employee-workdays/",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return await axios.create().request(config);
};
export const useCreateEmployeeWorkDays = () => {
  return useMutation(["employeeworkday-register"], createEmployeeWorkDays);
};

const employeeWorkDaysUpdate = async (data) => {
  let { id } = data;
  let config = {
    method: "patch",
    url: `/timesheet/api/v1/employee-workdays/${id}/`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  return await axios.request(config);
};
export const useEmployeeWorkDaysUpdate = () => {
  return useMutation(["workdays-update"], employeeWorkDaysUpdate);
};

const createWorkdays = async (payload) => {
  let config = {
    method: "post",
    url: "/timesheet/api/v1/workdays/",
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  };

  return await axios.create().request(config);
};
export const useCreateWorkdays = () => {
  return useMutation(["work-days-post"], createWorkdays);
};

const getWorkDaysDetail = async (query) => {
  let [, id] = query.queryKey;
  let config = {
    method: "get",
    url: `/timesheet/api/v1/workdays/${id}/`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};
export const useGetWorkDaysDetail = (id) => {
  return useQuery(["get-workday-by-id", id], getWorkDaysDetail, {
    enabled: id ? true : false,
  });
};

const workDaysUpdate = async (workdaysData) => {
  let { id, payload } = workdaysData;
  let config = {
    method: "patch",
    url: `/timesheet/api/v1/workdays/${id}/`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  };
  return await axios.request(config);
};
export const useWorkDaysUpdate = () => {
  return useMutation(["workdays-update"], workDaysUpdate);
};

const bulkUpload = async (timesheet) => {
  let config = {
    method: "post",
    url: "/timesheet/api/v1/timesheet_bulk_upload/",
    headers: {
      "Content-Type": "application/json",
    },
    data: timesheet,
  };

  return await axios.request(config);
};
export const usePostBulkUpload = () => {
  return useMutation(["post-bulkUpload"], bulkUpload);
};
